import { memo } from 'react'

import { HStack, Text } from '~/shared/ui'

import { LunyaAvatar } from '../LunyaAvatar'
import { LUNYA_LINE_AVATAR_SIZE } from './config'
import type { LunyaLineProps } from './types'

/**
 * Компактная строка-реплика Луни для вставки внутрь чужой карточки — обычно после
 * `Divider` (см. UI-кит §12: «У Мамы сегодня тихо…» под шкалой состояний, разбором и т.п.).
 */
export const LunyaLine = memo(function LunyaLine(props: LunyaLineProps) {
  const { text } = props

  return (
    <HStack gap='SMALL_L' align='CENTER'>
      <LunyaAvatar size={LUNYA_LINE_AVATAR_SIZE} />
      <Text variant='BODY_S' color='PRIMARY'>
        {text}
      </Text>
    </HStack>
  )
})
